const downloadTooltip = {
  tooltipText: 'We are working on this feature. Thank you for your interest.',
};

export default downloadTooltip;
